import type { TabId } from '../types';

export const tabForSection = (section: string): TabId | null => {
  if (section.startsWith('prior_deliveries')) {
    return 'accouchement';
  }
  if (section === 'pregnancy') {
    return 'grossesse';
  }
  if (section === 'family_history' || section === 'patient_medical_history') {
    return 'antecedent';
  }
  return null;
};

export const tabForFieldError = (fieldKey: string): TabId => {
  if (fieldKey.startsWith('prior_delivery_')) {
    return 'accouchement';
  }
  if (
    fieldKey.startsWith('pregnancy_') ||
    fieldKey.startsWith('preg_') ||
    [
      'grossesse_type',
      'grossesse_desiree',
      'grossesse_classee_a_risque',
      'risque_anemie',
      'risque_hta',
      'risque_diabete',
      'risque_cardiopathie',
      'risque_metrorragie',
      'risque_infection',
      'risque_preeclampsie',
      'risque_eclampsie',
      'risque_autre_details',
      'last_menstrual_period',
      'estimated_due_date',
      'lmp_is_estimated',
      'edd_is_estimated',
      'ga_weeks',
      'ga_days',
    ].includes(fieldKey)
  ) {
    return 'grossesse';
  }
  return 'core';
};
